<template>
  <div class="alert-message">
    <div class="lay_alert">
      <div v-show="showText" class="org_alert">
        <div class="m_slert_icon">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
        </div>
        <div class="m_alert">
          <div class="a_alert" :title="title">{{ title }}</div>
        </div>
        <div class="close" @click="close"><i class="fa fa-times" aria-hidden="true"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data() {
    return {
      showText: true,
    };
  },
  methods: {
    close: function () {
      this.showText = !this.showText;
    },
  },
};
</script>

<style lang="sass" scoped>
@mixin fx_center
  display: flex
  justify-content: center
  align-items: center

.alert-message
  position: absolute
  top: 12px
  right: 16px
  .org_alert
    // &.hide
    //   display: none
    position: relative
    width: 300px
    display: flex
    padding: 10px 4px
    line-height: 1.3
    border-radius: 6px
    background-color: #28c3cd
    color: #fff
    opacity: .9
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16)
    .close
      position: absolute
      right: 5px
      bottom: 4px
      i.fa.fa-times
        color: #002832
        font-size: 16px
        transition: .2s
        &:hover
          cursor: pointer
          opacity: .8
    .m_alert
      width: 245px
      font-size: 18px
      font-weight: 600
      text-align: justify
    .m_slert_icon
      +fx_center
      margin: 0 8px
      .fa.fa-check-circle
        font-size: 24px
</style>
